import {
  Component,
  Input,
  OnInit,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject, of } from 'rxjs';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'app-input-autocomplete',
  templateUrl: './input-autocomplete.component.html',
  styleUrls: ['./input-autocomplete.component.scss'],
  standalone: false,
})
export class InputAutocompleteComponent implements OnInit, OnDestroy {
  public filteredOptions$: Observable<InputAutocompleteOption[]>;
  public inputFormControl = new FormControl();
  public destroy$ = new Subject();

  @Input() placeholder = '';
  @Input() tooltip;
  @Input() isRequired;
  @Input() control: FormControl;
  @Input() label;
  @Input() options: InputAutocompleteOption[] = [];
  @ViewChild(AutoComplete) autoComplete: AutoComplete;

  ngOnInit(): void {
    this.filteredOptions$ = of([]);

    if (this.control?.value) {
      const initValue = this.options.find(
        option => option.value === this.control.value
      );
      if (initValue) {
        this.inputFormControl.setValue(initValue);
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onCompleteMethod(event: any) {
    const query = (event.query || '').toLowerCase();

    const filteredOptions = !query
      ? this.options
      : this.options.filter(option =>
          option.text.toLowerCase().includes(query)
        );

    this.filteredOptions$ = of(filteredOptions);
  }

  // onInput(event: any) {
  //   const value = event.target?.value || event.value || '';
  //   if (!value) {
  //     this.filteredOptions$ = of(this.options);
  //     setTimeout(() => {
  //       this.autoComplete?.show();
  //     });
  //   }
  // }

  clearField() {
    this.inputFormControl.setValue(null);
    if (this.control) {
      this.control.setValue(null);
    }
  }

  updateWithSelection(event: any) {
    if (this.control) {
      const valueToSet =
        event?.hasOwnProperty &&
        event?.hasOwnProperty('value') &&
        event.value?.hasOwnProperty &&
        event.value?.hasOwnProperty('value')
          ? event.value.value
          : event;
      this.control.setValue(valueToSet);
    }
  }
}

export interface InputAutocompleteOption {
  text: string;
  value: any;
}
